import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmailCreateTabManagerService } from '@services/email-create-tab-manager.service';
import { EmailSendingService } from '@services/email-sending.service';
import Hashids from 'hashids';

@Component({
  selector: 'wsb-email-create-template',
  templateUrl: './email-create-template.component.html',
  styleUrls: ['./email-create-template.component.scss'],
  standalone: false
})
export class EmailCreateTemplateComponent implements OnInit {
  @Output() selectedTemplateId: EventEmitter<any> = new EventEmitter();
  @Input() emailCampaignIssue;
  @Input() templateId;
  hashids;

  constructor(
    private emailSendingService: EmailSendingService,
    public emailCreateTabManagerService: EmailCreateTabManagerService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.createHashIds();

    this.listenToNextButton();

    this.checkIfTemplateIsSelected();
  }

  checkIfTemplateIsSelected() {
    if (this.templateId) {
      return this.useTemaplate(this.templateId);
    }
  }

  createHashIds() {
    this.translateService.get('pages_salt_hashids').subscribe(salt => {
      this.hashids = new Hashids(salt, 26, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890');
    });
  }

  listenToNextButton() {
    this.emailCreateTabManagerService.lgNext$.subscribe(tab => {
      if (tab === 2) {
        this.emailCreateTabManagerService.lgDone();
      }
    });
  }

  onTemplateSelected(template) {
    this.useTemaplate(template.idTemplate);
  }

  useTemaplate(templateId) {
    this.selectedTemplateId.emit(templateId);
    const obs$ = this.emailSendingService.useTemplate(this.emailCampaignIssue.idCampaignIssue, templateId);
    this.emailCreateTabManagerService.setTabIsReady(obs$);
    this.emailCreateTabManagerService.lgDone('editor');
  }
}
